export default (phone_number)=>{
  if(phone_number){
    let match = phone_number.match(/^(\d{3})(\d{3})(\d{4})$/)
    if(match){
      return '(' + match[1] + ') ' + match[2] + '-' + match[3]
    }
  }
  return null
}
